import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { motion } from 'framer-motion';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box
      sx={{
        bgcolor: 'background.default',
        pt: 8,
        pb: 6,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/images/hero-bg.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.1,
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center" sx={{ minHeight: '80vh' }}>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Typography
                component="h1"
                variant="h1"
                color="text.primary"
                gutterBottom
                sx={{ mb: 4, position: 'relative', zIndex: 1 }}
              >
                Start Your Own Profitable Tax Preparation Business Today!
              </Typography>
              <Typography
                variant="h5"
                color="text.secondary"
                paragraph
                sx={{ mb: 6, position: 'relative', zIndex: 1 }}
              >
                Take the guesswork out of launching your business—get the expert support and tools you need to succeed.
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, position: 'relative', zIndex: 1 }}>
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  onClick={() => scrollToSection('packages')}
                  sx={{ 
                    px: 4, 
                    py: 1.5,
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      transition: 'transform 0.2s ease-in-out',
                    }
                  }}
                >
                  View Packages
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  color="primary"
                  onClick={() => scrollToSection('why-choose-me')}
                  sx={{ 
                    px: 4, 
                    py: 1.5,
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      transition: 'transform 0.2s ease-in-out',
                    }
                  }}
                >
                  Learn More
                </Button>
              </Box>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              style={{ position: 'relative', zIndex: 1 }}
            >
              <Box
                component="img"
                src="/images/business-success/business-success-1.png"
                alt="Tax Business Success"
                sx={{
                  width: '100%',
                  maxWidth: 600,
                  height: 'auto',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;
